import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-24-地图-标记",
  "use": "icon-24-地图-标记-usage",
  "viewBox": "0 0 24 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 32\" id=\"icon-24-地图-标记\">\n<style type=\"text/css\">\n\t#icon-24-地图-标记 .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M12,0c6.63,0,12,5.38,12,12.19C24,19,18.76,25.06,12,32C5.25,25.14,0,19,0,12.19C0,5.38,5.37,0,12,0z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol